import React from 'react';

const SnowflakeOne = ({ className }) => (
  <svg className={className} viewBox="0 0 50 50">
    <path className="snowflake__flake snowflake__flake-1" d="M16,8h4v20h-4V8z" />
    <path className="snowflake__flake snowflake__flake-2" d="M8,20v-4h20v4H8z" />
    <path className="snowflake__flake snowflake__flake-3" d="M32,20v-4h4v4H32z" />
    <path className="snowflake__flake snowflake__flake-4" d="M0,20v-4h4v4H0z" />
    <path className="snowflake__flake snowflake__flake-5" d="M16,4V0h4v4H16z" />
    <path className="snowflake__flake snowflake__flake-6" d="M24,12V8h4v4H24z" />
    <path className="snowflake__flake snowflake__flake-7" d="M24,28v-4h4v4H24z" />
    <path className="snowflake__flake snowflake__flake-8" d="M8,12V8h4v4H8z" />
    <path className="snowflake__flake snowflake__flake-9" d="M8,28v-4h4v4H8z" />
    <path className="snowflake__flake snowflake__flake-10" d="M16,36v-4h4v4H16z" />
  </svg>
);

export default SnowflakeOne;



/** WEBPACK FOOTER **
 ** ./src/js/components/snowflake-one.js
 **/